const SCROLL_THRESHOLD = 200;
const FADE_DURATION = 200;

$(() => {
    const backToTopSelector = $(".back-to-top");

    backToTopSelector.on("click", function () {
        window.scroll({ top: 0, behavior: 'smooth' });
    });

    if (window.scrollY > SCROLL_THRESHOLD) {
        backToTopSelector.fadeIn(FADE_DURATION);
    }

    document.addEventListener('scroll', function () {
        if (window.scrollY > SCROLL_THRESHOLD) {
            backToTopSelector.fadeIn(FADE_DURATION);
        } else {
            backToTopSelector.fadeOut(FADE_DURATION);
        }
    });
})